export const DEFAULT_SORT_MODE = 'multiple'
export const DEFAULT_SORT_COLUMN = true
export const DEFAULT_RESPONSIV = true
export const DEFAULT_LAZY = true
export const COLUMN_RESIZE_EXPAND = 'expand'
export const COLUMN_RESIZE_FIT = 'fit'
export const DEFAULT_SELECTION_MODE = 'single'
export const EMPTY_MESSAGE = 'No records found'
export const DEFAULT_FILTER_MATCH_MODE = 'contains'
export const PAGE_SAZE_OPTIONS = [5, 10, 50, 100]
